<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <div v-if="!loading" class="tw-container tw-mx-auto">
        <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-8">
          <div v-if="!evaluationLoading">
            <div v-if="evaluation.status === 'NOT_APPLIED' && policy.coverCode !== 121" class="tw-w-full tw-px-4 md:tw-px-8">
              <div class="tw-w-full md:tw-w-3/4 tw-flex tw-items-center tw-bg-orange-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-full tw-border-orange-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                <schedule-inspection :policy-number="policy.policyNo" :scheduled="false" @inspection-scheduled="updateEvaluation" />
              </div>
            </div>
          </div>
          <div v-if="policy.toRenew" class="tw-mt-3">
            <div class="tw-w-full tw-px-4 md:tw-px-8">
              <div class="tw-w-full md:tw-w-1/2 tw-flex tw-items-center tw-bg-orange-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-full tw-border-orange-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                <p class="c-yellow-text tw-italic tw-text-xs md:tw-text-sm"><v-icon color="secondary">mdi-volume-high</v-icon> Your Policy is due for renewal.</p>
                <router-link :to="{ name: 'RenewPolicy', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }}" class="tw-bg-orange-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-full tw-text-xs md:tw-text-sm tw-cursor-pointer">RENEW POLICY</router-link>
              </div>
            </div>
          </div>
          <div v-if="isInstalmentDue(paymentSchedule)" class="tw-mt-3">
            <div class="tw-w-full tw-px-4 md:tw-px-8">
              <div class="tw-w-full md:tw-w-1/2 tw-flex tw-items-center tw-bg-orange-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-full tw-border-orange-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                <p class="c-yellow-text tw-italic tw-text-xs md:tw-text-sm"><v-icon color="secondary">mdi-volume-high</v-icon> Your Policy instalment due for payment.</p>
                <router-link :to="{ name: 'InstalmentPayment', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }}" class="tw-bg-orange-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-full tw-text-xs md:tw-text-sm tw-cursor-pointer">PAY INSTALMENT</router-link>
              </div>
            </div>
          </div>
          <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
            <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
              <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
                <img src="/images/icons/car-g.png" alt="car icon">
                <div class="tw-px-2 md:tw-px-8">
                  <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">{{ policy.coverType.replace('Insurance','') }} <br> Insurance</h3>
                  <p class="c-blue-text tw-text-sm tw-mt-2 md:tw-mt-4">{{policy.risks[0].model }}, {{ policy.risks[0].regno.toUpperCase() }}</p>
                </div>
              </div>
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400 tw-mt-5 md:tw-mt-0">
                <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">Policy Number:</h3>
                <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ policy.policyNo }}</h3>
              </div>
            </div>
          </div>

          <div class="tw-w-full tw-mt-3 md:tw-mt-8 tw-px-0 md:tw-mt-8 xl:tw-px-12">
            <v-tabs
                v-model="tab"
                background-color="transparent"
                color="primary"
                grow
            >
              <v-tab><v-icon size="20px" class="tw-mr-3">mdi-umbrella</v-icon>Overview</v-tab>
              <v-tab><v-icon size="20px" class="tw-mr-3">mdi-lock-plus</v-icon> Benefit Details</v-tab>
              <v-tab><v-icon size="20px" class="tw-mr-3">mdi-car</v-icon>Insured Asset Details</v-tab>
            </v-tabs>
            <hr>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card
                    color="basil"
                    flat
                >
                  <div class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
                    <div class="tw-w-full tw-flex">
                      <div class="tw-w-full tw-flex tw-justify-center md:tw-flex-no-wrap tw-flex-wrap tw-text-center md:tw-text-left tw-items-center tw-my-5 md:tw-my-8">
                        <div class="tw-w-full md:tw-w-1/2 tw-flex tw-flex-wrap md:tw-px-10">
                          <div v-if="policy.productCode !== 302" class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                            <p class="c-light-blue-text tw-text-base">Application Rate</p>
                            <p v-if="policy.coverCode === 121" class="c-gray-text tw-text-base">Ksh. {{ policy.rateApplied }}</p>
                            <p v-else class="c-gray-text tw-text-base">{{ policy.rateApplied }}%</p>
                          </div>
                          <div class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                            <p class="c-light-blue-text tw-text-base">Start Date</p>
                            <p class="c-gray-text tw-text-base">{{policy.wef | formatDate}}</p>
                          </div>
                          <div v-if="policy.productCode === 302 && policy.paymentSchedule" class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                            <p :class="['tw-text-base', diffDate(policy.wet) ? 'tw-text-red-500' : 'c-yellow-text']">Next Instalment</p>
                            <p :class="['tw-text-base', diffDate(policy.wet) ? 'tw-text-red-500' : 'c-gray-text']">
                              {{ scanObject(policy, 'paymentSchedule.0.dueDate')  }}
                            </p>
                          </div>
                          <div class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                            <p :class="['tw-text-base', diffDate(policy.wet) ? 'tw-text-red-500' : 'c-yellow-text']">Renewal Date</p>
                            <p :class="['tw-text-base', diffDate(policy.wet) ? 'tw-text-red-500' : 'c-gray-text']">
                              {{ policy.wet | formatDate }}
                            </p>
                          </div>
                        </div>
                        <div class="tw-w-full md:tw-w-1/2 tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400">
                          <h4 class="c-blue-text tw-font-bold tw-text-sm">Total Annual Premium</h4>
                          <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ policy.totalPremium | formatNum }}</h3>
                        </div>
                      </div>
                    </div>
                    <hr>

                    <div class="tw-w-full tw-px-0 md:tw-px-16 tw-mt-3 md:tw-mt-8">
                      <p>Instalments</p>
                    </div>
                    <div v-if="!scheduleLoading"   class="tw-w-full tw-flex tw-mt-2">
                      <template v-if="paymentSchedule.length > 0">
                        <div v-if="policy.productCode = 302" class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 md:tw-flex-no-wrap tw-flex-wrap">
                          <div class="tw-w-full md:tw-w-2/3 tw-flex tw-flex-wrap md:tw-px-10">
                            <div v-for="(schedule, $index) in paymentSchedule" :key="$index" class="tw-w-full tw-flex tw-px-1 md:tw-px-6">
                              <p class="tw-w-1/2 tw-px-2 c-light-blue-text tw-text-base">Next Instalment</p>
                              <p class="tw-w-1/2 tw-px-2 c-gray-text tw-text-base"><span>KSH  {{ schedule.amount | formatNum }} <small :class="[schedule.paymentStatus === 'PAID' ? 'tw-text-green-500' : 'tw-text-red-500' ]">{{ schedule.paymentStatus === 'PAID' ? 'PAID' : 'due - ' + formatDate(schedule.dueDate)}}</small></span></p>
                            </div>
                          </div>
                          <div class="tw-w-full md:tw-w-1/3 tw-px-0 md:tw-px-10 tw-mt-6 md:tw-mt-0 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400">
                            <h4 class="c-light-blue-text tw-text-sm tw-italic">Dear customer After the month that is due has been paid for, <u>the next month will be available for payment</u></h4>
                            <div>
                              <v-btn :to="{ name: 'InstalmentPayment', params: { policyNo: policy.policyNo, batchNo: policy.batchNo, quoteId: scanObject(policy, 'paymentSchedule.0.quoteId') }, query: { type: 'instalment' }}" class="tw-mt-5" block color="secondary">
                                Pay {{ formatDateToMonth(scanObject(policy, 'paymentSchedule.0.dueDate'))  }} - KSH {{ scanObject(policy, 'paymentSchedule.0.amount')  | formatNum }}
                              </v-btn>
                            </div>
                          </div>
                        </div>
                        <div v-else class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 md:tw-flex-no-wrap tw-flex-wrap">
                          <div class="tw-w-full md:tw-w-2/3 tw-flex tw-flex-wrap md:tw-px-10">
                            <div v-for="(schedule, $index) in paymentSchedule" :key="$index" class="tw-w-full tw-flex tw-px-1 md:tw-px-6">
                              <p class="tw-w-1/2 tw-px-2 c-light-blue-text tw-text-base">{{ formatPercentage(schedule.distribution) }}% of total premium</p>
                              <p class="tw-w-1/2 tw-px-2 c-gray-text tw-text-base"><span>KSH  {{ schedule.amount | formatNum }} <small :class="[schedule.paymentStatus === 'PAID' ? 'tw-text-green-500' : 'tw-text-red-500' ]">{{ schedule.paymentStatus === 'PAID' ? 'PAID' : 'due - ' + formatDate(schedule.dueDate)}}</small></span></p>
                            </div>
                          </div>
                          <div class="tw-w-full md:tw-w-1/3 tw-px-0 md:tw-px-10 tw-mt-6 md:tw-mt-0 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400">
                            <div v-if="unpaidSchedule.length === 2">
                              <h4 class="c-blue-text tw-text-sm tw-italic">You can either pay 30% - {{ paymentSchedule[0].amount | formatNum }} for another month or pay the remaining 60% - {{ (paymentSchedule[0].amount + paymentSchedule[1].amount)  | formatNum }} to cover the remaining 11 months</h4>
                              <div>
                                <v-btn :to="{ name: 'InstalmentPayment', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }, query: { type: 'instalment' }}" class="tw-mt-5" block color="secondary">Pay 30% - KSH {{ paymentSchedule[0].amount | formatNum }}</v-btn>
                                <v-btn :to="{ name: 'InstalmentPayment', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }, query: { full: 'full', type: 'instalment'  }}" class="tw-mt-5" block color="secondary">Pay 60% - KSH {{ (paymentSchedule[0].amount + paymentSchedule[1].amount)  | formatNum }}</v-btn>
                              </div>
                            </div>
                            <div v-else-if="unpaidSchedule.length === 1">
                              <h4 class="c-blue-text tw-text-sm tw-italic">You can pay the remaining 30% - {{ paymentSchedule[0].amount | formatNum }} </h4>
                              <div>
                                <v-btn :to="{ name: 'InstalmentPayment', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }, query: { type: 'instalment' }}" class="tw-mt-5" block color="secondary">Pay 30% - KSH {{ paymentSchedule[0].amount | formatNum }}</v-btn>
                              </div>
                            </div>
                            <div v-else>
                              <h4 class="tw-text-green-500 tw-text-sm tw-italic">All policy payments are upto date. You will be notified on your renewal </h4>
                            </div>
                          </div>
                        </div>
                      </template>
                      <div v-else class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 md:tw-flex-no-wrap tw-flex-wrap">
                        <div class="tw-w-full md:tw-w-2/3 tw-flex tw-flex-wrap md:tw-px-10">
                          <div class="tw-w-full tw-flex tw-px-1 md:tw-px-6">
                            <p class="tw-w-1/2 tw-px-2 c-light-blue-text tw-text-base">100% of total premium</p>
                            <p class="tw-w-1/2 tw-px-2 c-gray-text tw-text-base"><span>KSH  {{ policy.totalPremium | formatNum }} <small class="tw-text-green-500">PAID</small></span></p>
                          </div>
                        </div>
                        <div class="tw-w-full md:tw-w-1/3 tw-px-0 md:tw-px-10 tw-mt-6 md:tw-mt-0 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400">
                          <div>
                            <h4 class="tw-text-green-500 tw-text-sm tw-italic">All policy payments are upto date. You will be notified on your renewal </h4>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="!evaluationLoading">
                      <div v-if="evaluation.status !== 'NOT_APPLIED'">
                        <div class="tw-w-full tw-px-0 md:tw-px-16 tw-mt-3 md:tw-mt-8">
                          <p>Inspection</p>
                        </div>
                        <div class="tw-w-full tw-mt-3 tw-px-0 md:tw-px-16">
                          <div class="tw-bg-orange-200 tw-rounded-lg c-gray-text tw-p-3 tw-flex tw-justify-between">
                            <div>
                              <p>You have a scheduled inspection for <strong>{{policy.risks[0].model }} {{ policy.risks[0].regno.toUpperCase() }}</strong></p>
                              <p><strong>Date:</strong> {{ evaluation.date | formatDate }} </p>
                              <p><strong>Time:</strong> {{ evaluation.time }} HRS</p>
                            </div>
                            <a href="#" @click.prevent="deleteSchedule"><span class="tw-text-red-500 tw-underline">Cancel Appointment</span></a>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card
                    color="basil"
                    flat
                >
                  <div class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
                    <div class="tw-w-full tw-px-0 md:tw-px-16 tw-mt-3 md:tw-mt-8">
                      <p class="tw-font-bold">Top & Other Free Benefits</p>
                    </div>
                    <div class="tw-w-full tw-flex tw-px-0 md:tw-px-12">
                      <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-mb-5 tw-grid tw-grid-cols-1 md:tw-grid-cols-4">
                        <ul v-for="(b,i) in policy.benefits" :key="i">
                          <li class="tw-mt-8 c-gray-text">{{ b.apaNarration }}</li>
                          <li class="c-blue-text tw-mt-0">Free Limit - Ksh {{ b.value }}</li>
                        </ul>
                      </div>
                    </div>

                    <div v-if="policy.coverCode !== 121" class="tw-w-full tw-px-0 md:tw-px-16 tw-mt-3 md:tw-mt-8">
                      <p class="tw-font-bold">Purchased Benefits</p>
                    </div>
                    <div v-if="policy.coverCode !== 121" class="tw-w-full tw-flex tw-mt-2 tw-px-0 md:tw-px-16">
                      <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-grid tw-grid-cols-1 md:tw-grid-cols-3">
                        <v-checkbox v-for="(b, i) in policy.chargedBenefits" :key="i" v-model="check" class="tw-mt-3" readonly>
                          <template #label>
                            <ul>
                              <li> {{ b.narration }}</li>
                              <li class="c-blue-text tw-mt-1">Ksh {{ b.chargedAmount | formatNum }}</li>
                            </ul>
                          </template>
                        </v-checkbox>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card
                    color="basil"
                    flat
                >
                  <div class="tw-mt-3 md:tw-mt-12">
                    <div v-for="(car, i) in policy.risks" :key="i" class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-10 tw-flex-wrap tw-mt-4">
                      <div class="tw-w-full md:tw-w-1/2 tw-flex tw-px-2 md:tw-px-10 tw-items-center tw-border-r-0 md:tw-border-r-2 tw-border-gray-400">
                        <img src="/images/icons/car-g.png" alt="car icon">
                        <div class="tw-px-2 md:tw-px-8">
                          <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">{{ car.model }}, {{ car.covertype }} <br> 2019</h3>
                        </div>
                      </div>
                      <div class="tw-w-full md:tw-w-1/2 tw-flex tw-flex-wrap md:tw-px-10">
                        <div class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                          <p class="c-light-blue-text tw-text-base">Registration Number</p>
                          <p class="c-gray-text tw-text-base">{{ car.regno }} </p>
                        </div>
                        <div class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                          <p class="c-light-blue-text tw-text-base">Sum Insured</p>
                          <p class="c-gray-text twty-text-base">KSH {{ car.suminsured | formatNum }}</p>
                        </div>
                        <div class="tw-w-full tw-flex tw-justify-between tw-px-1 md:tw-px-6">
                          <p class="c-light-blue-text tw-text-base">Premium</p>
                          <p class="c-gray-text twty-text-base">KSH {{ car.riskPremium | formatNum}}</p>
                        </div>
                      </div>
                      <hr>
                    </div>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-card>
      </div>
      <div v-else class="tw-w-full tw-flex tw-justify-center">
        <v-progress-circular
            :size="40"
            color="primary"
            indeterminate
        ></v-progress-circular>
      </div>
    </div>
  </default>
</template>

<script>
/* eslint-disable no-param-reassign */

import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import axios from 'axios';
import moment from 'moment';
import helpers from '@/utils/helpers';
import ScheduleInspection from '@/components/buy/ScheduleInspection';
import {
  diffDate, diffDate2, isInstalmentDue, formatDateToMonth,
} from '@/utils/time';

export default {
  name: 'SinglePolicy',
  components: { ScheduleInspection, BreadCrumb, Default },
  data(vm) {
    return {
      breadcrumbs: [
        {
          text: 'My Policies',
          disabled: false,
          to: { name: 'MyPolicies' },
        },
        {
          text: 'My Policy',
          disabled: true,
          to: { name: 'SinglePolicy', params: { policyNo: vm.$route.params.policyNo } },
        },
      ],
      tab: null,
      check: true,
      loading: true,
      scheduleLoading: false,
      evaluationLoading: true,
      evaluation: {},
    };
  },
  computed: {
    paymentSchedule() {
      return this.policy.paymentSchedule === null ? [] : this.policy.paymentSchedule;
    },
    unpaidSchedule() {
      return this.paymentSchedule.filter((p) => p.paymentStatus === 'PENDING') || [];
    },
    policy() {
      return this.$store.state.policy;
    },
  },
  metaInfo: {
    title: 'My Policy',
  },
  mounted() {
    this.$store.dispatch('getPolicy', this.$route.params.policyNo).then(() => {
      this.loading = false;
      if (this.policy.coverCode === 120) this.getEvaluation();
    });
  },
  methods: {
    formatDateToMonth,
    getEvaluation() {
      axios.get(`/customer/quotation/evaluation/status?policyNumber=${this.$route.params.policyNo}`)
        .then((response) => {
          this.evaluation = response.data;
          this.evaluationLoading = false;
        });
    },
    deleteSchedule() {
      // eslint-disable-next-line no-restricted-globals,no-alert
      if (confirm('Are you sure you want to cancel ?')) {
        axios.delete('/customer/quotation/evaluation/cancel', { data: { policyNumber: this.$route.params.policyNo } })
          .then(() => {
            this.$toast.success('Appointment Cancelled');
            this.evaluation.status = 'NOT_APPLIED';
          });
      }
    },
    formatDate(date) {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      return moment(date, 'Do MMM YYYY').format('Do MMM YYYY');
    },
    formatPercentage(num) {
      num *= 100;
      num = num.toString();
      num = num.split('.');
      num = parseInt(num[0], 10);
      num /= 100;
      return num;
    },
    updateEvaluation(data) {
      this.evaluation = data;
    },
    diffDate,
    diffDate2,
    isInstalmentDue,
  },
  filters: {
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('Do MMM YYYY');
    },
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
